import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const WelcomePage = ({ onStart }) => {
  return (
    <div 
      className="min-h-screen w-full flex flex-col items-center justify-center relative overflow-hidden"
      data-testid="welcome-page"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1770513649465-2c60c8039806?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHx3ZWlnaHRlZCUyMHB1bGwlMjB1cCUyMGNhbGlzdGhlbmljcyUyMGF0aGxldGUlMjBkYXJrJTIwZ3ltfGVufDB8fHx8MTc3MzE3NTU5OXww&ixlib=rb-4.1.0&q=85')`
        }}
      />
      <div className="absolute inset-0 bg-mono-base/90" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        {/* Brand Mark */}
        <div className="mb-8">
          <span className="text-crimson font-heading text-sm font-bold uppercase tracking-[0.3em]">
            Coach Rands Method
          </span>
        </div>
        
        {/* Main Title */}
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter text-white mb-6 leading-none">
          0 to 20KG
          <span className="block text-crimson">in 12 Weeks</span>
        </h1>
        
        {/* Subtitle */}
        <p className="text-white text-lg md:text-xl font-body mb-12 max-w-xl mx-auto leading-relaxed">
          Your personalised weighted pull-up coaching system.
          <span className="block text-mono-mute mt-2">Built by Coach Rands.</span>
        </p>
        
        {/* CTA Button */}
        <Button 
          onClick={onStart}
          className="bg-white hover:bg-[#E5E5E5] text-black font-heading font-bold text-lg uppercase tracking-wider rounded-none px-10 py-6 h-auto transition-colors duration-200 active:scale-95 group"
          data-testid="start-module-1-btn"
        >
          Start Module 1
          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
        </Button>
        
        {/* Footer Text */}
        <p className="text-mono-mute text-sm mt-16 font-body">
          No account required. Start training immediately.
        </p>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-crimson/30 to-transparent" />
    </div>
  );
};

export default WelcomePage;
